import { makeAutoObservable, runInAction } from 'mobx';
import { cleanByRoomService } from 'services/CalculationServices/cleanByRoomService';

export class CleanByRoomStore {
  cleanByToomTableData: {}[] = [];
  isLoading: boolean = false;
  isAllRoomCleanDataAvailable: boolean = true;

  constructor() {
    makeAutoObservable(this);
  }

  fetchCleanByRoomData = async (date: string) => {
    this.isLoading = true;
    try {
      const response = await cleanByRoomService.getCleanByRoomData(date);
      runInAction(() => {
        this.cleanByToomTableData = response.data;
      });
    } catch (error) {
      runInAction(() => {
        this.cleanByToomTableData = [];
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };
}
